module.exports = __webpack_public_path__ + "img/img_know_1.321da4bf.png";